module.exports = __webpack_public_path__ + "img/f18604020bf6702b848e99f4e4a7bfe1.5b80558e.png";